






















import {Vue, Component, Prop} from 'vue-property-decorator'
import {Action} from 'vuex-class'

import {ReservationResponse} from '@/lib/kepler/interfaces'
import BookingDetailMixin from '@/lib/BookingDetailMixin'
import Utils from '@/utils'

@Component({
  components: {
    BookingActions: Utils.loadComponent('BookingActions'),
    ReservationVehicleAndDates: Utils.loadComponent('entities/reservation/ReservationVehicleAndDates'),
    HorizontalHighlight: Utils.loadComponent('HorizontalHighlight'),
    Card: Utils.loadComponent('proxy/Card/Card'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Container: Utils.loadComponent('proxy/Container'),
    CardTitle: Utils.loadComponent('proxy/Card/CardTitle'),
    TripList: Utils.loadComponent('entities/reservation/TripList'),
    VehicleLotAndDistance: Utils.loadComponent('entities/vehicle/VehicleLotAndDistance'),
    Divider: Utils.loadComponent('proxy/Divider'),
  },
  name: 'HistoryBookingDetail',
  mixins: [BookingDetailMixin],
})
export default class HistoryBookingDetail extends Vue {
  @Action('deleteReservation') public deleteReservation: any
  @Action('editReservation') public editReservation: any
  @Action('openDialog') public openDialog: any
  @Action('closePopup') public closePopup: any

  @Prop() public reservation!: ReservationResponse
}
